import React, {useEffect, useState, useContext} from 'react';
import {Block} from '../block';
import {set, cloneDeep, isUndefined} from 'lodash';
import {MarkdownBlock} from '../markdown-block';
import {TextBlock} from '../text-block';
import {OpenApiContext} from '../../openapi-context';

export function OverviewBlock({schema, className, onCancel, onSave, rootPath}) {
    const {state, dispatch} = useContext(OpenApiContext);
    const [editedSchema, setEditedSchema] = useState();

    useEffect(() => {
        if (!isUndefined(schema)) {
            setEditedSchema(cloneDeep(schema));
        }
    }, [schema]);

    function handleSave() {
        dispatch({type: 'terminate'});
        return onSave && onSave(editedSchema);
    }

    function handleCancel() {
        dispatch({type: 'terminate'});
        return onCancel && onCancel();
    }

    const setDescription = (value) => set(editedSchema, 'description', value);
    const triggerEdit = () => dispatch({type: 'activate', message: 'changes to specification overview'});
    const setTitle = (value) => set(editedSchema, 'title', value);
    // 3.1: info.summary is a short one-liner intended to sit between the
    // title and the long description. Editing it is additive — 3.0 specs
    // simply have `undefined` and the field stays blank.
    const setSummary = (value) => set(editedSchema, 'summary', value);

    return !isUndefined(schema) ? (
        <Block className={className} onCancel={handleCancel} onSave={handleSave} onEdit={triggerEdit}>
            <TextBlock hiddenValue={true} value={schema.title} placeholder="Title" onValue={setTitle} delegatedEditMode={state.editMode} />
            <TextBlock hiddenValue={true} value={schema.summary} placeholder="Summary (short one-liner, OpenAPI 3.1)" onValue={setSummary} delegatedEditMode={state.editMode} />
            <MarkdownBlock source={schema.description} size={700} placeholder="Type description" onValue={setDescription} delegatedEditMode={state.editMode} imageRootPath={rootPath} />
        </Block>
    ) : null;
}
